import { useStreamUserDefinedRange } from '../../stores/stream-screen.store';
import { useLoadRangeAtTs } from '../range/useLoadRangeAtTs';

/**
 * Hook to move the stream backwards.
 */

export function useGoBackwards() {
  const range = useStreamUserDefinedRange();
  const loadStream = useLoadRangeAtTs();

  return (ms: number) => {
    return loadStream(range.from - ms);
  };
}
